import { render } from "./Initialization.vue?vue&type=template&id=4dee8a6e&scoped=true&ts=true"
import script from "./Initialization.vue?vue&type=script&lang=ts"
export * from "./Initialization.vue?vue&type=script&lang=ts"

import "./Initialization.vue?vue&type=style&index=0&id=4dee8a6e&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dee8a6e"]])

export default __exports__